import { styled } from '@mui/material';
import { useParams } from 'react-router';
import { ROUTES } from '../../constants/routes';
import { PerformanceTab } from '../SIngleCompany/components/PerformanceTab';
import { ChecklistTab } from '../SIngleCompany/components/ChecklistTab/ChecklistTab';

const Wrapper = styled('div')`
  padding-top: 16px;
`;

export const TabsContent = () => {
  const { activeTab } = useParams();
  return (
    <Wrapper>
      {activeTab === ROUTES.COMPANY_PERFORMANCE && <PerformanceTab />}
      {activeTab === ROUTES.COMPANY_CHECKLIST && <ChecklistTab />}
    </Wrapper>
  );
};
